var map = {
	"./back.svg": 19,
	"./calendar.svg": 21,
	"./cancel.svg": 68,
	"./check.svg": 69,
	"./copy.svg": 70,
	"./downarrow.svg": 22,
	"./error.svg": 71,
	"./exit.svg": 23,
	"./expand.svg": 9,
	"./expand_base.svg": 24,
	"./flag.svg": 40,
	"./gray_left.svg": 41,
	"./help.svg": 20,
	"./left.svg": 16,
	"./purchases.svg": 72,
	"./star.svg": 11,
	"./stars.svg": 73,
	"./store.svg": 74,
	"./success.svg": 75,
	"./tick.svg": 25,
	"./uparrow.svg": 26
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 39;